import React from 'react'

const SecondaryButton = ({ label, icon: Icon, onClick, disabled, className = '', textColor = 'gray', ...props }) => {
  return (
    <button
      onClick={onClick}
      className={`min-w-[120px] flex items-center justify-center gap-2 px-4 py-2 rounded-lg font-medium transition-all duration-200 text-sm
        ${disabled
        ? 'bg-gray-100 text-gray-700 cursor-not-allowed'
        : `border border-gray-200 text-${textColor}-500 hover:border hover:border-${textColor}-500`
      }
        ${className}`}
      {...props}
    >
      {Icon && <Icon className="w-5 h-5" />}
      {label}
    </button>
  )
}

export default SecondaryButton